var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15521D48-65B2-45D2-AA1C-D0F84D28DC5D@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tablet-and-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet---Giving-History---Sort-Date",
    transform: "translate(-713.000000, -709.000000)",
    fill: "#48D2A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(564.000000, 696.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.946753,14.4980129 L153.886513,22.9893593 C153.815517,23.0641529 153.700562,23.0641529 153.629732,22.9893593 L149.053123,18.1677928 C148.982292,18.0933487 148.982292,17.972246 149.053123,17.8974523 L150.165177,16.7259188 C150.236174,16.6512999 150.351128,16.6512999 150.421959,16.7259188 L153.758288,20.2405194 L160.578083,13.0559641 C160.649245,12.9813453 160.763868,12.9813453 160.834864,13.0559641 L161.946753,14.2274977 C162.017749,14.3021165 162.017749,14.4230445 161.946753,14.4980129 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.15445cf2f1f14ea3e5c1e2d728e68cee.svg";
export { ForwardRef as ReactComponent };